import { onError } from 'apollo-link-error';
import { ApolloLink } from '@apollo/client/core';

export const errorLink = () =>
  onError(({ response }) => {
    console.error(response);
  }) as unknown as ApolloLink;
